const isDevServer = () => {
  return process.env.devServer;
};

const isIPAddress = (url: string) => {
  if (
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      url,
    )
  ) {
    return true;
  }
  console.log('You have entered an invalid IP address!');
  return false;
};

const isLocalhost = () => {
  return location.hostname === 'localhost';
};

const isMobile = () => {
  let userAgent = navigator.userAgent;
  let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  return Agents.some((i) => {
    return userAgent.includes(i);
  });
};

const ifEmpty = (value: any) => {
  if (value === undefined || value === null) {
    return true;
  } else {
    return !value.toString() || !value.toString().replace(/\s/g, '');
  }
};

const jumpDependOnEnv = (url: string, needNewPage: boolean) => {
  let finalUrl = url;
  if (isDevServer()) {
    finalUrl = url.replace(
      url.split('/client')[0],
      `${isLocalhost() && needNewPage ? location.host : location.origin}`,
    );
  }
  if (needNewPage) {
    window.open(finalUrl, '_blank');
  } else {
    window.location.href = finalUrl;
  }
};

const getTransDetail = (detail: any) => {
  let details = '';
  try {
    if (detail) {
      for (const key in detail) {
        if (detail.hasOwnProperty(key)) {
          details += `[${key}]: ${detail[key]} <br />`;
        }
      }
    }
  } catch (e) {
    console.log('error: get trans details', e);
    details = '';
  }
  return details;
};

const imgToBase64 = (file: any) => {
  return new Promise<string>((resolve, reject) => {
    let obj = file;
    if (!file.type.includes('image/')) {
      reject(Error('NOT_CORRECT_IMAGE'));
    }
    try {
      let reader = new FileReader();
      reader.readAsDataURL(obj);
      reader.onload = () => {
        let path = reader.result;
        let img: any = new Image();
        img.src = path;
        img.onload = () => {
          let w = img.width;
          let h = img.height;
          let scale = w / h;
          w = obj.width || w;
          h = obj.height || w / scale;
          let quality = 0.7;
          let canvas = document.createElement('canvas');
          let ctx: any = canvas.getContext('2d');
          let anw: any = document.createAttribute('width');
          anw.nodeValue = w;
          let anh: any = document.createAttribute('height');
          anh.nodeValue = h;
          canvas.setAttributeNode(anw);
          canvas.setAttributeNode(anh);
          ctx.drawImage(img, 0, 0, w, h);
          if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
            quality = obj.quality;
          }
          let base64 = canvas.toDataURL('image/jpeg', quality);
          resolve(base64);
        };
      };
    } catch (e) {
      reject(e);
    }
  });
};

const yyyymmddToDdmmyyyy = (origin: string) => {
  // console.log('origin date', origin);
  const [year, month, day] = origin.split('-');
  const result = `${day}/${month}/${year}`;
  // console.log('parsed date', result);
  return result;
};

const ddmmyyyyToYyyymmdd = (origin: string) => {
  // console.log('origin date', origin);
  const [day, month, year] = origin.split('/');
  const result = `${year}-${month}-${day}`;
  // console.log('parsed date', result);
  return result;
};

export {
  yyyymmddToDdmmyyyy,
  ddmmyyyyToYyyymmdd,
  imgToBase64,
  isMobile,
  isDevServer,
  jumpDependOnEnv,
  ifEmpty,
  getTransDetail,
};
